import {formatHuman} from "./dateUtils";

const monthsBetween = (start, end) => {
    const months = []
    const cursor = new Date(start.getFullYear(), start.getMonth(), 1)
    const last = new Date(end.getFullYear(), end.getMonth(), 1)
    while (cursor <= last) {
        months.push({year: cursor.getFullYear(), month: cursor.getMonth() + 1})
        cursor.setMonth(cursor.getMonth() + 1)
    }
    return months
}

const isRangeFullyAvailable = async (fetchMonthlyAvailability, priceId, start, end) => {
    const months = monthsBetween(start, end)
    const results = await Promise.all(months.map(m => fetchMonthlyAvailability(priceId, m.year, m.month)))
    const merged = {}
    results.forEach(r => Object.assign(merged, r))
    const cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate())
    const last = new Date(end.getFullYear(), end.getMonth(), end.getDate())
    while (cursor <= last) {
        if (!merged[formatHuman(cursor)]) return false
        cursor.setDate(cursor.getDate() + 1)
    }
    return true
}

export {monthsBetween, isRangeFullyAvailable}
